import { Permission, flattenPermissions, hasPermission } from "../types/permissions";

export { Permission, hasPermission };

/**
 * Legacy permission check — walks the nested permission tree on every call.
 *
 * Prefer reading `state.user.permissionSet` from Redux and calling
 * `hasPermission(Permission.Xyz, permissionSet)` -- the list is a plain
 * `string[]` (serializable state), and role permission lists are short.
 * This wrapper is kept for backward compatibility during migration.
 */
const validatePermission = (permission: string, permissions: any): boolean => {
  if (permission === Permission.PermissionNotDefined) return true;

  const permissionSet = flattenPermissions(permissions);
  return permissionSet.has(permission);
};

export default validatePermission;
